import * as React from "react";
import {
  Grid,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  SortDirection,
  Paper,
} from "@mui/material";

import { H3 } from "~/dashboard/components/typography";
import { useAppDispatch, useAppSelector } from "~/state/hooks";
import { getDownloadFileData } from "~/state/stats/selectors";
import { formatMessage } from "~/utils/translation";
import { getEventsData } from "~/state/stats/actions";
import { getComparator } from "~/dashboard/components/table/utils";

import { messages } from "./intl";
import { stableSort, TableHead } from "~/dashboard/components/table";
import { useTable } from "~/dashboard/hooks/useTable";

export const EventData = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  React.useEffect(() => {
    dispatch(getEventsData());
  }, [dispatch]);

  const downloadFileData = useAppSelector(getDownloadFileData);

  const downloadColumns = [
    {
      id: "sessionId",
      align: "left",
      disablePadding: false,
      label: formatMessage(messages.volume),
    },
    {
      id: "event_count",
      align: "left",
      disablePadding: false,
      label: formatMessage(messages.totalDownloads),
    },
  ];

  const {
    page,
    order,
    orderBy,
    rowsPerPage,
    handleChangePage,
    handleRequestSort,
    handleChangeRowsPerPage,
  } = useTable({
    defaultOrderBy: "event_count",
    defaultOrder: "desc",
    defaultRowsPerPage: 12,
  });

  return (
    <Grid container spacing={3} sx={{ marginTop: 4 }}>
      {downloadFileData ? (
        <Grid item xs={12} md={6}>
          <H3>{formatMessage(messages.fileDownloads)}</H3>
          <Paper sx={{ mb: 2 }}>
            <TableContainer>
              <Table sx={{ minWidth: 600 }}>
                <TableHead
                  order={order as SortDirection}
                  orderBy={orderBy}
                  headCells={downloadColumns}
                  onRequestSort={handleRequestSort}
                />

                <TableBody>
                  {stableSort(downloadFileData, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={row.planId}
                          onClick={() => {}}
                        >
                          <TableCell component="th" scope="row">
                            {formatMessage(messages.planVolumeTitle, {
                              planTitle: row.title,
                              volumeNumber: row.volumeNumber,
                            })}
                          </TableCell>

                          <TableCell>{row.event_count}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              page={page}
              component="div"
              count={downloadFileData?.length || 0}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              rowsPerPageOptions={[12, 48, 96]}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      ) : null}
    </Grid>
  );
};
